/**
 * Provides an interface for editing forms.
 * ## Fields
 * Name | Description
 * --- | ---
 * model | The `Layer` associated with the editor.
 * @module app/views/layer/LayerEditor
 */
import Backbone from "backbone";
import _ from "underscore";
import FieldSetEditor from "app/views/layer/FieldSetEditor";
import FormInputView from "core/views/FormInputView";
import Field from "core/models/Field";
import Layer from "app/models/Layer";
import "../../../../styles/specific/field-editor.scss";
export default Backbone.View.extend({
  template: _.template(
    '<div class="details-container"></div> <div class="question-container"></div>'
  ),
  tagName: "form",

  className: "data-type-editor",

  attributes: {
    "data-ajax": false,
    action: "",
  },

  events: {
    submit: function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    },
  },

  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {Layer} options.model The `Layer` to associate with the editor.
   */
  initialize: function (options) {
    this.options = options;

    this.model = this.options.model;
  },

  render: function () {
    var self = this;

    var nameFieldField = this.model.createNameFieldField();
    var fields = [
      new Field(Layer.fields["name"]),
      nameFieldField,
      new Field(Layer.fields.showLabels),
    ];

    this.stopListening();

    this.$el.html(this.template(this.options));

    _.each(
      fields,
      function (field) {
        var inputView = new FormInputView({
          model: this.options.model,
          field: field,
        });

        this.listenTo(field, "value-added", function () {
          inputView.render();
        });
        this.listenTo(field, "value-updated", function () {
          inputView.render();
        });
        inputView.render();

        if (field === nameFieldField) {
          var oldRender = inputView.render;

          inputView.render = _.debounce(function () {
            oldRender.apply(inputView, arguments);
          }, 250);
        }

        this.$(".details-container").append(inputView.$el);
      },
      this
    );

    var view = (this.view = new FieldSetEditor({
      fields: this.model.getFields(),
    }));

    var fieldCollection = this.model.getFields();

    this.listenTo(fieldCollection, "change", function (changed) {
      self.model.updateNameField(
        changed.get("id") || changed.cid,
        changed.get("label")
      );
    });
    view.render();
    this.$(".question-container").append(view.$el);
  },

  save: function () {
    return this.model.save();
  },

  remove: function () {
    Backbone.View.prototype.remove.apply(this, arguments);
    this.view.remove();
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/layer/LayerEditor.js
// module id = 491
// module chunks = 1